(() => {
  if (customElements.get('video-popup')) {
    return;
  }

  class VideoPopup extends HTMLElement {
    constructor() {
      super();

      this.triggers = this.querySelectorAll('.js-video-trigger');

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          let isOpen = false;
          const popupSelector = document.querySelector(trigger.dataset.popup);
          const video = popupSelector.querySelector('video');

          if (trigger.classList.contains('button--open')) {
            isOpen = true;
          }

          if (isOpen) {
            this.openVideo(popupSelector);
          } else {
            this.closeVideo(popupSelector);
          }
        });
      });
    }

    openVideo(selector) {
      selector.classList.add('open');
      selector.querySelector('video').muted = false;
      selector.querySelector('video').play();

      // Find the close icon and add a click event listener
      const closeIcon = selector.querySelector('.close-icon');
      closeIcon?.addEventListener('click', () => {
        this.closeVideo(selector);
      });

      selector.querySelector('video').addEventListener('ended', (event) => {
        this.closeVideo(selector);
      });
    }

    closeVideo(selector) {
      selector.classList.remove('open');
      selector.querySelector('video').pause();
      selector.querySelector('video').currentTime = 0;
    }
  }

  customElements.define('video-popup', VideoPopup);
})();
